// Atlas Novus — parallax suave estilo Apple para imagenes de fondo de seccion
(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  var strength = 0.18; // intensidad del desplazamiento (0-1)
  var targets = [];
  var ticking = false;

  function collectTargets() {
    targets = Array.prototype.slice.call(
      document.querySelectorAll('.custom-section-background')
    );
  }

  function updateParallax() {
    var viewportHeight = window.innerHeight;

    targets.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > viewportHeight) return;

      var centerOffset = rect.top + rect.height / 2 - viewportHeight / 2;
      var offset = centerOffset * strength * -1;
      var maxOffset = rect.height * 0.15;
      if (offset > maxOffset) offset = maxOffset;
      if (offset < -maxOffset) offset = -maxOffset;

      el.style.setProperty('--av-parallax-offset', offset.toFixed(1) + 'px');
    });

    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(updateParallax);
      ticking = true;
    }
  }

  function init() {
    collectTargets();
    updateParallax();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      collectTargets();
      updateParallax();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    collectTargets();
    updateParallax();
  });
})();
